import React from 'react';
import { Calendar, MapPin, CheckCircle } from 'lucide-react';
import { featuredProject } from '../data/mockData';

const FeaturedProject = () => {
  const details = featuredProject.details || [];
  
  return (
    <section id="projects" className="py-24 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Featured Project
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            {featuredProject.title}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="relative animate-fadeInLeft">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src={featuredProject.image}
                alt={featuredProject.title}
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
            </div>
            
            {/* Floating info card */}
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-xl max-w-xs">
              <div className="flex items-center space-x-3 mb-3">
                <Calendar className="w-5 h-5 text-blue-600" />
                <span className="font-semibold text-gray-900">{featuredProject.date}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-blue-600" />
                <span className="text-sm text-gray-600">{featuredProject.location}</span>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-6 animate-fadeInRight">
            <p className="text-lg text-gray-700 leading-relaxed">
              {featuredProject.description}
            </p>

            {/* Details List */}
            <div className="bg-white p-6 rounded-2xl border border-blue-100 shadow-sm">
              <h3 className="font-semibold text-gray-900 mb-4 text-lg">Rincian Kegiatan:</h3>
              <div className="space-y-3">
                {details.length > 0 && details[0] && (
                  <div className="flex items-start space-x-3 group">
                    <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                    <span className="text-gray-700">{details[0]}</span>
                  </div>
                )}
                {details.length > 1 && details[1] && (
                  <div className="flex items-start space-x-3 group">
                    <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                    <span className="text-gray-700">{details[1]}</span>
                  </div>
                )}
                {details.length > 2 && details[2] && (
                  <div className="flex items-start space-x-3 group">
                    <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                    <span className="text-gray-700">{details[2]}</span>
                  </div>
                )}
                {details.length > 3 && details[3] && (
                  <div className="flex items-start space-x-3 group">
                    <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                    <span className="text-gray-700">{details[3]}</span>
                  </div>
                )}
              </div>
            </div>

            {/* Impact Stats */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-blue-50 p-6 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="text-3xl font-bold text-blue-600 mb-1">25+</div>
                <div className="text-sm text-gray-600">Relawan Terlibat</div>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="text-3xl font-bold text-blue-600 mb-1">50+</div>
                <div className="text-sm text-gray-600">Anak Terbantu</div>
              </div>
            </div>

            {/* CTA Button */}
            <button className="w-full bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition-all duration-300 hover:shadow-lg hover:scale-105">
              Lihat Dokumentasi Lengkap
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProject;
